import { Component, OnInit } from '@angular/core';

import { IndicadorService } from '../services/indicador.service';
import { GlobalsService } from '../services/globals.service';
import { UsuarioService } from '../services/usuario.service';
import { Indicadores } from '../Models/Indicadores';
import { Usuario } from '../Models/Usuario';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-indicador-entrega-chofer',
  templateUrl: './indicador-entrega-chofer.component.html',
  styleUrls: ['./indicador-entrega-chofer.component.css']
})
export class IndicadorEntregaChoferComponent implements OnInit {

  indicador: Indicadores = new Indicadores();
  indicadores: Indicadores[] = [];

  usuario: Usuario = new Usuario();
  usuarios: Usuario[] = [];

  fechaInicio: Date;
  fechaFin: Date;

  numeroVisitas: number = 0;

  estado: string = "GENERAL";

  constructor(
    private usuarioService: UsuarioService,
    private globalServices: GlobalsService,
    private indicadorService: IndicadorService
  ) { }

  ngOnInit() {

    this.ObtenerUsuarios();
  }

  ObtenerUsuarios() {

    this.usuarioService.ObtenerUsuariosComboBox(this.globalServices.ObtenerCompania()).subscribe(
      data => {
        this.usuarios = JSON.parse(JSON.stringify(data));
      },
      error => {
        console.log(error);
      }
    );

  }

  ObtenerEntregaChofer() {

    if (isNullOrUndefined(this.fechaInicio)) {
      this.fechaInicio = new Date();
    }
    if (isNullOrUndefined(this.fechaFin)) {
      this.fechaFin = new Date();
    }

    if (isNullOrUndefined(this.usuario.idUsuario)) {
      return;
    }

    this.numeroVisitas = 0;

    this.indicadorService.ObtenerEntregasChofer(this.globalServices.ObtenerCompania(),
      this.usuario.idUsuario, this.fechaInicio, this.fechaFin, this.estado).subscribe(
        data => {
          this.indicadores = JSON.parse(JSON.stringify(data));
          this.usuario =  JSON.parse(JSON.stringify( this.usuarios.find(f => f.idUsuario == this.usuario.idUsuario)));

          this.indicadores.forEach(element => {
            this.numeroVisitas = this.numeroVisitas + Number.parseInt(element.resultado);
          });

        },
        error => {
          console.log(error);
        }


      );

  }

  /**
    * Convierte la tabla asignada en un exel
    * @param tableID 
    * @param filename 
    */
  exportTableToExcel(tableID, filename = '') {

    if (this.indicadores.length == 0) {
      return;
    }

    var downloadLink;
    var dataType = 'application/vnd.ms-excel';
    var tableSelect = document.getElementById(tableID);
    var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

    // Specify file name
    filename = filename ? filename + '.xls' : 'excel_data.xls';

    // Create download link element
    downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);

    if (navigator.msSaveOrOpenBlob) {
      var blob = new Blob(['\ufeff', tableHTML], {
        type: dataType
      });
      navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      // Create a link to the file
      downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

      // Setting the file name
      downloadLink.download = filename;

      //triggering the function
      downloadLink.click();
    }
  }


}
